import { GlobalStyles } from '@mui/material';
import type { CSSProperties } from 'react';
import React from 'react';

const styles: Record<string, CSSProperties> = {
  '*': {
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
  },
  html: {
    margin: 0,
    padding: 0,
    fontSize: '16px',
    WebkitTextSizeAdjust: '100%',
  },
  body: {
    margin: 0,
    padding: 0,
    backgroundColor: '#131A21',
    fontFamily: '"GT Walsheim Medium", "GT Walsheim Medium Placeholder", sans-serif',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    overflowX: 'hidden',
  },
  'input, textarea, select, button': {
    fontFamily: 'inherit',
  },
  'button, input, select, textarea': {
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    appearance: 'none',
  },
  'button:focus, input:focus, select:focus, textarea:focus': {
    outline: 'none',
  },
  'a': {
    textDecoration: 'none',
    color: 'inherit',
  },
  'img': {
    maxWidth: '100%',
    height: 'auto',
  },
};

export const GlobalStylesComponent: React.FC = () => <GlobalStyles styles={styles} />; 